import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { DateTime } from 'luxon';

@Pipe({
  name: 'longDate',
  standalone: true,
})
export class LongDatePipe implements PipeTransform {
  private transloco = inject(TranslocoService);

  /**
   * @param date The date to format
   * @param monthFormat 'short' | 'long' (default: 'short')
   * @param includeWeekday include the weekday in the output (default: true)
   */
  transform(
    date: Date | DateTime | string,
    monthFormat: 'short' | 'long' = 'short',
    includeWeekday: boolean = true
  ): string {
    let dt: DateTime;

    if (date instanceof DateTime) {
      dt = date;
    } else if (typeof date === 'string') {
      dt = DateTime.fromISO(date);
    } else {
      dt = DateTime.fromJSDate(date);
    }

    dt = dt.setLocale(this.transloco.getActiveLang());

    const options: Intl.DateTimeFormatOptions = {
      year: 'numeric',
      month: monthFormat,
      day: 'numeric'
    };

    if (includeWeekday) {
      options.weekday = 'long';
    }

    const formattedDate = dt.toLocaleString(options);
    return formattedDate;
  }
}
